<!--服务标签-->
<template>
    <div class="tag-list">
        <span class="tag-item" v-for="(item, index) in tagList" :key="index">{{item.name}}</span>
    </div>
</template>
<script>
    export default {
        props: {
            tagList: {
                type: Array,
                default: () => []
            }
        }
    }
</script>
<style lang="scss" scoped>
    .tag-list {
        display: flex;
        flex-wrap: wrap;
        .tag-item {
            font-size:14px;
            font-weight:400;
            color:rgba(34,34,34,1);
            padding: 12px 11px;
            margin-right: 16px;
            background: rgba(248, 64, 37, 0.1) url('./label_logo.png') right bottom no-repeat;
            margin-bottom: 10px;
        }
    }
</style>